<template>
  <!-- 
    Copyright (c) 2024 Lenovo. All right reserved.
    Confidential and Restricted 
  -->
  <div id="app" class="base-scroll">
    <template v-if="isLoginPage">
      <Login></Login>
    </template>
    <template v-else>
      <Menu />
      <main class="mainEl" ref="mainContainer">
          <router-view class="main-container"/>
      </main>
      <img src="@/assets/asideLogo.png" alt="" class="asideLogo">
    </template>
  </div>
</template>

<script>
// Copyright (c) 2024 Lenovo. All right reserved.
// Confidential and Restricted
import Vue from "vue"
import Menu from '@/components/Menu';
import Login from '@/views/login';
import zh from "./locales/zh";
export default {
  name: 'Lenovo_LDFM_App',
  data() {
    return {
      
    }
  },
  computed: {
    isLoginPage() {
      return this.$route.path === "/login";
    }
  },
  methods: {
    updateRootFontSize() {
      const baseFontSize = 16; // Basic font size  
      const designWidth = 1920; // Design draft width 
      const width = window.innerWidth; // Current window width  
      const fontSize = (width / designWidth) * baseFontSize; // Calculate the new font size  
      Vue.prototype.fontSize = fontSize;
    },
    lockEl(e) {      
      let temLockElArr = [], temIndex = null;
      if(e.key === "Tab" && this.$lockInfo.uuidList.slice(-1)) {
        let temEl = document.querySelector(`[regionLock="${this.$lockInfo.uuidList.slice(-1)}"]`);
        if(!temEl) return;
        temLockElArr = Array.from(temEl.querySelectorAll('[tabIndex]:not([tabIndex="-1"]), input, select, textarea, button, [contentEditable="true"], a[href]'));
        for (let i = 0; i < temLockElArr.length; i++) {
          if(temLockElArr[i] === e.target) {
            temIndex = i;
            break;
          }
        }
        if(e.shiftKey) {
          if(temIndex === 0) {
            temIndex = temLockElArr.length - 1;
            e.preventDefault();
          }
        } else {
          if(temIndex === (temLockElArr.length - 1)) {
            temIndex = 0;
            e.preventDefault();
          }
        }
        temLockElArr[(temIndex || 0)].focus();
      } else {

      }
    },
  },
  created() {
    window.addEventListener('keydown', this.lockEl);
  },
  mounted() {
    // Initialize the font size of the root element
    this.updateRootFontSize();

  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.lockEl);
  },
  components: {
    Menu,
    Login
  }
}
</script>

<style lang="scss" scoped>
#app {
  overflow: hidden;
  background-color: var(--base-primary-back-color);
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  overflow:hidden;
  .asideLogo {
    width: 33px;
    right: 0px;
    bottom: 62px;
    position: fixed;
    z-index: 99;
  }
}
#app .mainEl {
  position: relative;
  box-sizing: border-box;
  height: calc( 100% - 73px );
}
.main-container {
  box-sizing: border-box;
  padding: 24px 50px 27px 30px;
  height: 100%
}

.el-scrollbar__wrap{
  overflow: hidden !important;
}


</style>
